import React, {Component} from 'react';
import {connect} from 'react-redux';
import Alert from 'react-s-alert';

const showConsole = false;

class ImageDragAndDrop extends Component {


    constructor(props) {
        super(props);
        // if (showConsole) console.log("ImageDragAndDrop::constructor()");

        this.element = undefined;
        this.state = {
            options:
                {
                    width: null,
                    height: null,
                    image: null,
                    ghost: true,
                    originalsize: false,
                    url: false,
                    removeurl: null,
                    data: {},
                    canvas: true,
                    canvasImageOnly: false,
                    ajax: true,
                    resize: false,
                    dimensionsonly: false,
                    editstart: false,
                    saveOriginal: true,
                    save: true,
                    download: false,

                    smaller: true,
                    smallerWidth: false,
                    smallerHeight: false,
                    background: null,


                    onAfterZoomImage: null,
                    onAfterInitImage: null,
                    onAfterMoveImage: null,
                    onAfterProcessImage: null,
                    onAfterResetImage: null,
                    onAfterCancel: null,
                    onAfterRemoveImage: null,
                    onAfterSelectImage: null,

                },
            input: undefined,
            imageData: {}
        };


        this.window = $(window);
        this.interval = null;
        this.drag = false;

        //buttons
        this.button = {};
        this.button.edit = '<div class="btn btn-control-dragdrop btn-info btn-edit" title="' + (this.state.options.editTitle || 'Editar') + '" ><i class="las la-lg la-edit"></i><span style="font-size: 10px;">Editar</span></div>';
        this.button.saving = '<div class="btn btn-control-dragdrop btn-warning saving">' + (this.state.options.saveLabel || 'Cargando...') + ' <i class="las la-lg la-clock"></i><span style="font-size: 10px;"></span></div>';
        this.button.zoomin = '<div class="btn btn-control-dragdrop btn-primary btn-zoom-in" title="' + (this.state.options.zoominTitle || 'Zoom in') + '"><i class="las la-lg la-search-plus"></i><span style="font-size: 10px;">Ampliar</span></div>';
        this.button.zoomout = '<div class="btn btn-control-dragdrop btn-primary btn-zoom-out" title="' + (this.state.options.zoomoutTitle || 'Zoom out') + '"><i class="las la-lg la-search-minus"></i><span style="font-size: 10px;">Reducir</span></div>';
        this.button.zoomreset = '<div class="btn btn-control-dragdrop btn-primary btn-zoom-reset" title="' + (this.state.options.zoomresetTitle || 'Tamaño completo') + '"><i class="las la-lg la-expand-arrows-alt"></i><span style="font-size: 10px;">Ajustar</span></div>';
        this.button.cancel = '<div class="btn btn-control-dragdrop btn-danger btn-cancel" title="' + (this.state.options.cancelTitle || 'Cancelar') + '"><i class="las la-lg la-times"></i><span style="font-size: 10px;">Cancelar</span></div>';
        this.button.done = '<div class="btn btn-control-dragdrop btn-success btn-ok" title="' + (this.state.options.okTitle || 'Ok') + '"><i class="las la-lg la-check"></i><span style="font-size: 10px;">Terminar</span></div>';
        this.button.del = '<div class="btn btn-control-dragdrop btn-danger btn-del" title="' + (this.state.options.delTitle || 'Eliminar') + '"><i class="las la-lg la-trash"></i><span style="font-size: 10px;">Eliminar</span></div>';

        this.button.download = '<a class="btn btn-warning download"><i class="glyphicon glyphicon-download"></i>' + (this.state.options.downloadLabel || 'Descargar') + '</a>';

        this.imageMimes = {
            webp: 'image/webp',
            png: 'image/png',
            bmp: 'image/bmp',
            gif: 'image/gif',
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            tiff: 'image/tiff'
        };

    }

    init() {
        if (showConsole) console.log("ImageDragAndDrop::init()");
        const that = this;
        if (this.empty(this.element)) {
            return false;
        } else {
            this.element.children().css({position: 'absolute'})
        }

        //the engine of this script
        if (!(window.FormData && ("upload" in ($.ajaxSettings.xhr())))) {
            this.element.empty().attr('class', '').addClass('alert alert-danger').html('HTML5 Subir Imagen: Lamentablemente.. este navegador no soporta el plugin, ¡actualiza tu navegador hoy mismo!');
            return false;
        }

        if ((!this.empty(this.state.options.width) || !this.empty(this.state.options.height)) && this.empty(this.state.options.height) && this.element.innerHeight() <= 0) {
            this.element.empty().attr('class', '').addClass('alert alert-danger').html('HTML5 Subir Imagen: La altura de la imagen no está configurada y no se puede calcular...');
            return false;
        }

        //copy styles
        this.element.data('style', this.element.attr('style'));
        this.element.data('class', this.element.attr('class'));

        //check sizes
        let width, height, imageWidth, imageHeight;

        this.state.options.width = imageWidth = this.state.options.width || this.element.outerWidth();
        this.state.options.height = imageHeight = this.state.options.height || this.element.outerHeight();

        if (showConsole) console.log("this.state.options.width = '" + this.state.options.width + "'");
        if (showConsole) console.log("this.element.outerWidth() = '" + this.element.outerWidth() + "'");
        if (showConsole) console.log("this.state.options.height = '" + this.state.options.height + "'");
        if (showConsole) console.log("this.element.outerHeight() = '" + this.element.outerHeight() + "'");

        width = this.state.options.width;
        height = this.state.options.height;

        if (showConsole) console.log("width = '" + width + "'");
        if (showConsole) console.log("height = '" + height + "'");


        height = height || width / (imageWidth / imageHeight);
        width = width || height / (imageHeight / imageWidth);

        if (showConsole) console.log("width = '" + width + "'");
        if (showConsole) console.log("height = '" + height + "'");


        /* is small window, add class small */
        if (width < 240) {
            this.element.addClass('smalltools smalltext');
        }


        if (showConsole) console.log("this.element.css() = '" + JSON.stringify({height: height, width: width}) + "'");
        this.element.css({height: height, width: width});
        this.widthPercentage = (this.element.outerWidth() / this.element.offsetParent().width()) * 100;
        if (showConsole) console.log("this.widthPercentage = '" + this.widthPercentage + "'");

        if (this.state.options.resize === true) {
            this.window.resize(function () {
                that.resize();
            })
        }
        this._bind();

        if (this.state.options.required || this.input.prop('required')) {
            this.state.options.required = true;
            this.input.prop('required', true);
        }

        if (!this.state.options.ajax) {
            this._formValidation();
        }

        if (!this.empty(this.state.options.image) && this.state.options.editstart === false) {

            this.element.data('name', this.state.options.image).append($('<img />').addClass('preview').attr('src', this.state.options.image));

            let tools = $('<div class="preview tools"></div>');
            let edit = $('' + this.button.edit + '');
            let del = $('' + this.button.del + '');

            $(del).unbind('click').click(function (e) {
                // if(showConsole) if (showConsole) console.log("Boton Del::click()");

                e.preventDefault();
                e.cancelable = true;
                that.reset();
            });

            if (this.state.options.buttonDel !== false) {
                $(tools).append(del)
            }

            this.element.append(tools);
        } else if (!this.empty(this.state.options.image)) {
            this.readImage(this.state.options.image, this.state.options.image, this.state.options.image, this.imageMimes[this.state.options.image.split('.').pop()], true); //$(img).attr('src'),)
        }

        if (this.state.options.onAfterInitImage) this.state.options.onAfterInitImage.call(this, this);
    }

    _bind() {
        // if (showConsole) console.log("ImageDragAndDrop::_bind()");
        //bind the events
        var that = this;
        this.element.unbind('dragover drop mouseout').on({
            dragover: function (event) {
                // if(showConsole) if (showConsole) console.log("_bind::unbindDragover::dragover()");
                that.handleDrag(event)
            },
            drop: function (event) {
                // if(showConsole) if (showConsole) console.log("_bind::unbindDragover::drop()");
                that.handleFile(event, $(that))
            },
            mouseout: function () {
                // if(showConsole) if (showConsole) console.log("_bind::unbindDragover::mouseout()");
                // $(document).unbind('mouseup touchend').on('mouseup touchend', function (e) {
                // that.element.on('mouseup touchend', function (e) {
                //     if(showConsole) if (showConsole) console.log("_bind::unbindDragover:mouseout:unbind()");
                // e.preventDefault();
                // e.cancelable = true;
                that.imageUnhandle();
                // })
            }
        });

        that.input.unbind('change').change(function (event) {
            // if(showConsole) if (showConsole) console.log("this::input::unbind(change)::change()");
            that.drag = false;
            that.handleFile(event, that.element)
        });

    }

    handleFile(event, element) {
        if (showConsole) console.log("ImageDragAndDrop::handleFile()");
        event.stopPropagation();
        event.preventDefault();

        let files = (this.drag === false) ? event.originalEvent.target.files : event.originalEvent.dataTransfer.files; // FileList object.
        this.drag = false;

        var that = this;

        // this.reset();
        if (that.state.options.removeurl !== null && !that.empty(that.element.data('name'))) {
            $.ajax({
                type: 'POST',
                url: that.state.options.removeurl,
                data: {image: that.element.data('name')},
                success: function (response) {
                    if (that.state.options.onAfterRemoveImage) that.state.options.onAfterRemoveImage.call(that, response, that);
                }
            })
        }

        that.element.removeClass('notAnImage').addClass('loading');//.unbind('dragover').unbind('drop');

        for (let i = 0, f; f = files[i]; i++) {
            if (!f.type.match('image.*')) {
                that.element.addClass('notAnImage');
                continue;
            }

            let reader = new FileReader();

            reader.crossOrigin = "Anonymous";
            reader.onload = (function (theFile) {
                //if(this.props.elementId=== 0) if(showConsole) if (showConsole) console.log(theFile);
                return function (e) {
                    that.element.find('img').remove();
                    that.readImage(reader.result, e.target.result, theFile.name, theFile.type, true);
                };
            })(f);
            reader.readAsDataURL(f);
        }
        let response;
        if (that.state.options.onAfterSelectImage) that.state.options.onAfterSelectImage.call(that, response, that);
    }

    readImage(image, src, name, mimeType, init) {
        if (showConsole) console.log("ImageDragAndDrop::readImage()");
        this.drag = false;
        let img = new Image;
        var that = this;
        img.crossOrigin = "Anonymous";
        img.onload = (tmp) => {
            if (showConsole) console.log("ImageDragAndDrop::readImage()::onload()");
            let imgElement = $('<img src="' + src + '" name="' + name + '" />');
            let width, height, useWidth, useHeight, ratioImagenLoad, elementContainerRatio;


            const widthImagenLoad = img.width
            const heightImagenLoad = img.height
            width = useWidth = widthImagenLoad;
            height = useHeight = heightImagenLoad;
            ratioImagenLoad = height / width;

            if (showConsole) console.log("SizeImagenLoad = '" + JSON.stringify({
                width: widthImagenLoad,
                height: heightImagenLoad,
                ratio: ratioImagenLoad
            }) + "'");
            elementContainerRatio = that.element.innerHeight() / that.element.innerWidth();
            if (showConsole) console.log("SizesElementContainer = '" + JSON.stringify({
                outerWidth: that.element.outerWidth(),
                outerHeight: that.element.outerHeight(),
                innerWidth: that.element.innerWidth(),
                innerHeight: that.element.innerHeight(),
                ratio: elementContainerRatio
            }) + "'");


            //resize image
            if (showConsole) console.log("Calculando resize de image")
            if (that.state.options.originalsize === false) {
                if (showConsole) console.log("that.state.options.originalsize === false");
                //need to add the option is smaller = true, dont resize
                //also if the image == 100% the size of the element, dont add extra space

                useWidth = that.element.innerWidth();
                useHeight = useWidth * ratioImagenLoad;
                if (showConsole) console.log("useWidth = '" + useWidth + "'");
                if (showConsole) console.log("useHeight = '" + useHeight + "'");


            } else if (useWidth < that.element.outerWidth() || useHeight < that.element.outerHeight()) {
                if (showConsole) console.log("true -> useWidth < that.element.outerWidth() || useHeight < that.element.outerHeight()");
                if (that.state.options.smaller === true) {
                    //do nothing
                } else {
                    if (ratioImagenLoad < elementContainerRatio) {
                        useWidth = that.element.outerWidth();
                        useHeight = useWidth / ratioImagenLoad;
                    } else {
                        useHeight = that.element.outerHeight();
                        useWidth = useHeight * ratioImagenLoad;
                    }
                }
            }


            if (showConsole) console.log("Calculando tamaño y posicion de imagen en el frame");
            if (showConsole) console.log("useWidth = '" + useWidth + "'");
            if (showConsole) console.log("that.element.innerWidth() = '" + that.element.innerWidth() + "'");
            let left = parseFloat((that.element.innerWidth() - useWidth) / 2); // * -1;
            if (showConsole) console.log("left = '" + left + "'");

            if (showConsole) console.log("useHeight = '" + useHeight + "'");
            if (showConsole) console.log("that.element.innerHeight() = '" + that.element.innerHeight() + "'");
            let top = parseFloat(((that.element.innerWidth() * 0.75) - useHeight) / 2); // * -1;
            if (showConsole) console.log("top = '" + top + "'");

            const cssImageObj = {left: left, top: top, width: useWidth, height: useHeight}
            if (showConsole) console.log("cssImageObj = '" + JSON.stringify(cssImageObj) + "'");
            imgElement.css(cssImageObj);


            const imageElementData = {
                mime: mimeType,
                width: width,
                height: height,
                ratio: ratioImagenLoad,
                left: left,
                top: top,
                useWidth: useWidth,
                useHeight: useHeight
            }

            if (showConsole) console.log("imageElementData = '" + JSON.stringify(imageElementData) + "'");

            that.image = $(imgElement)
                .clone()
                .data(imageElementData)
                .addClass('main')
                .bind('mousedown touchstart', function (event) {
                    // if(showConsole) if (showConsole) console.log("onload()::bind(mousedown touchstart)");
                    that.imageHandle(event);
                });
            that.imageGhost = (that.state.options.ghost) ? $(imgElement).addClass('ghost') : null;

            //place the images
            that.element.append($('<div class="cropWrapper"></div>').append($(that.image)));
            if (!that.empty(that.imageGhost)) {
                that.element.append(that.imageGhost);
            }

            //that.element.unbind('dragover').unbind('drop');
            that.addEventListenerToTools();

            if (!init) {
                that.imageFinal();
                that.imageCrop();
            }

            //clean up
            that.element.removeClass('loading');
        };
        img.src = image;
    }

    handleDrag(event) {
        if (showConsole) console.log("ImageDragAndDrop::handleDrag()");
        this.drag = true;
        event.stopPropagation();
        event.preventDefault();
        event.originalEvent.dataTransfer.dropEffect = 'copy';
    }

    imageHandle(e) {
        // if (showConsole) console.log("ImageDragAndDrop::imageHandle()");
        e.preventDefault();
        e.cancelable = true; // disable selection
        let event = (e.originalEvent.touches || e.originalEvent.changedTouches) ? e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] : e;


        let height = this.image.outerHeight(),
            width = this.image.outerWidth(),
            cursor_y = this.image.offset().top + height - event.pageY,
            cursor_x = this.image.offset().left + width - event.pageX;

        var that = this;
        // if(showConsole) if (showConsole) console.log("ImageDragAndDrop::imageHandle()");
        // $(document).on({
        // this.element.on({
        $('#' + this.props.elementId).find("img").on({
            'dragstart mousemove touchmove': (e) => {
                // if(showConsole) if (showConsole) console.log("imageHandle()::dragstart mousemove touchmove()");
                $('body').css({cursor: 'move'});

                e.stopImmediatePropagation();
                // e.preventDefault();
                e.cancelable = true;

                let event = (e.originalEvent.touches || e.originalEvent.changedTouches) ? e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] : e;

                let imgTop = event.pageY + cursor_y - height,
                    imgLeft = event.pageX + cursor_x - width;
                let hasBorder = (that.element.outerWidth() !== that.element.innerWidth());

                if (that.state.options.smaller === false) {

                    if (parseInt(imgTop - that.element.offset().top) > 0) {
                        imgTop = that.element.offset().top + ((hasBorder) ? 1 : 0);
                    } else if (imgTop + height < that.element.offset().top + that.element.outerHeight()) {
                        imgTop = that.element.offset().top + that.element.outerHeight() - height + ((hasBorder) ? 1 : 0);
                    }

                    if (parseInt(imgLeft - that.element.offset().left) > 0) {
                        imgLeft = that.element.offset().left + ((hasBorder) ? 1 : 0);
                    } else if (imgLeft + width < that.element.offset().left + that.element.outerWidth()) {
                        imgLeft = that.element.offset().left + that.element.outerWidth() - width + ((hasBorder) ? 1 : 0);
                    }
                }

                that.image.offset({
                    top: imgTop,
                    left: imgLeft
                });
                that._ghost();
            },
            'dragend mouseup touchend': function (e) {
                // if(showConsole) if (showConsole) console.log("ImageHandle()::dragend mouseup touchend() --> imageUnhandle()");
                e.preventDefault();
                that.imageUnhandle();
            }
        })

    }

    imageUnhandle() {
        // if (showConsole) console.log("ImageDragAndDrop::imageUnhandle()");
        // $(document).unbind('mousemove touchmove');
        $('#' + this.props.elementId).find("img").unbind('mousemove touchmove');
        $('body').css({cursor: ''});
        if (this.state.options.onAfterMoveImage) this.state.options.onAfterMoveImage.call(this, this);
    }

    imageZoom(x) {
        if (showConsole) console.log("ImageDragAndDrop::imageZoom()");
        if (this.empty(this.image)) {
            this._clearTimers();
            return false;
        }

        let ratio = this.image.data('ratio');
        let newWidth = this.image.outerWidth() + x;
        let newHeight = newWidth * ratio;

        if (this.state.options.smaller === false) {

            //smaller then element?
            if (newWidth < this.element.outerWidth()) {
                newWidth = this.element.outerWidth();
                newHeight = newWidth / ratio;
            }
            if (newHeight < this.element.outerHeight()) {
                newHeight = this.element.outerHeight();
                newWidth = newHeight * ratio;
            }
        } else {
            if (newWidth < 1 || newHeight < 1) {
                if (newWidth > newHeight) {
                    newWidth = 1;
                    newHeight = newWidth / ratio;
                } else {
                    newHeight = 1;
                    newWidth = newHeight * ratio;
                }
            }
        }

        let newTop = this.image.css('top').replace(/[^-\d\.]/g, '') - (newHeight - this.image.outerHeight()) / 2;
        let newLeft = this.image.css('left').replace(/[^-\d\.]/g, '') - (newWidth - this.image.outerWidth()) / 2;


        if (this.state.options.smaller === false) {

            if (this.element.offset().left - newLeft < this.element.offset().left) {
                newLeft = 0;
            } else if (this.element.outerWidth() > newLeft + $(this.image).outerWidth() && x <= 0) {
                newLeft = this.element.outerWidth() - newWidth;
            }

            if (this.element.offset().top - newTop < this.element.offset().top) {
                newTop = 0;
            } else if (this.element.outerHeight() > newTop + $(this.image).outerHeight() && x <= 0) {
                newTop = this.element.outerHeight() - newHeight;
            }
        }

        this.image.css({width: newWidth, height: newHeight, top: newTop, left: newLeft});
        this._ghost();

    }

    imageCrop(isModified, isCancel) {
        if (showConsole) console.log("ImageDragAndDrop::imageCrop()");
        const that = this;
        let cuttingFrameWidth, cuttingFrameHeight, cuttingTop, cuttingLeft, imageWidthParaCortar, imageHeightParaCortar,
            imageOriginalWidth,
            imageOriginalHeight;


        if (showConsole) console.log("Calculando tamaño de marco para la imagen");
        const tamMarcoImagenWidth = this.element.innerWidth();
        const tamMarcoImagenHeight = tamMarcoImagenWidth * 0.75;
        if (showConsole) console.log("tamMarcoImagenWidth = '" + tamMarcoImagenWidth + "'");
        if (showConsole) console.log("tamMarcoImagenHeight = '" + tamMarcoImagenHeight + "'");

        // cuttingFrameWidth = this.element.outerWidth();
        // cuttingFrameHeight = cuttingFrameWidth * 0.75;

        cuttingFrameWidth = tamMarcoImagenWidth;
        cuttingFrameHeight = tamMarcoImagenHeight

        if (showConsole) console.log("Cogiendo tamaño de imagen original");
        imageOriginalWidth = this.image.data('width');
        imageOriginalHeight = this.image.data('height');
        if (showConsole) console.log("imageOriginalWidth = '" + imageOriginalWidth + "'");
        if (showConsole) console.log("imageOriginalHeight = '" + imageOriginalHeight + "'");

        if (showConsole) console.log("cogiendo coordenadas de corte de imagen");
        cuttingTop = parseInt(Math.round(parseInt(this.image.css('top')))) || 0;
        cuttingLeft = parseInt(Math.round(parseInt(this.image.css('left')))) || 0;
        if (showConsole) console.log("cuttingTop = '" + cuttingTop + "'");
        if (showConsole) console.log("cuttingLeft = '" + cuttingLeft + "'");

        if (showConsole) console.log("this.image.width() = '" + this.image.width() + "'");
        if (showConsole) console.log("this.image.height() = '" + this.image.height() + "'");

        if (showConsole) console.log("isModified = '" + isModified + "' - isCancel = '" + isCancel + "'");
        if (isModified || isCancel) {
            if (showConsole) console.log("Cogiendo datos tamaño de imagen modificada o previa para cortar");
            imageWidthParaCortar = parseInt(Math.round(this.image.width()));
            imageHeightParaCortar = parseInt(Math.round(this.image.height()));
        } else {
            if (showConsole) console.log("Cogiendo datos del tamaño de marco para cortar");
            imageWidthParaCortar = tamMarcoImagenWidth
            imageHeightParaCortar = tamMarcoImagenHeight
        }


        if (showConsole) console.log("imageWidthParaCortar = '" + imageWidthParaCortar + "'");
        if (showConsole) console.log("imageHeightParaCortar = '" + imageHeightParaCortar + "'");
        if (showConsole) console.log("imageOriginalWidth = '" + imageOriginalWidth + "'");
        if (showConsole) console.log("imageOriginalHeight = '" + imageOriginalHeight + "'");
        if (showConsole) console.log("----------------------");

        let obj = {
            name: this.image.attr('name'),
            imageOriginalWidth: imageOriginalWidth,
            imageOriginalHeight: imageOriginalHeight,
            imageWidth: imageWidthParaCortar,
            imageHeight: imageHeightParaCortar,
            width: cuttingFrameWidth,
            height: cuttingFrameHeight,
            cuttingFrameHeight: cuttingFrameHeight,
            cuttingFrameWidth: cuttingFrameWidth,
            left: cuttingLeft,
            top: cuttingTop,
            objName: "obj",
            isModified: isModified
        };

        let obj_save = {
            name: this.image.attr('name'),
            imageOriginalWidth: imageOriginalWidth,
            imageOriginalHeight: imageOriginalHeight,
            imageWidth: this.image.width(),
            imageHeight: this.image.height(),
            width: cuttingFrameWidth,
            height: cuttingFrameHeight,
            left: this.image.css('left'),
            top: this.image.css('top'),
            objName: "obj_save",
            isModified: isModified
        };

        this.element.find('.tools').children().toggle();
        this.element.find('.tools').append($(this.button.saving));

        if (this.state.options.canvas === true) {
            if (showConsole) console.log("this.state.options.canvas === true");
            let canvas = $('<canvas class="final" id="canvas_' + this.input.attr('name') + '" width="' + Math.round(cuttingFrameWidth) + '" height="' + Math.round(cuttingFrameHeight) + '" style="position:absolute; top: 0; bottom: 0; left: 0; right: 0; z-index:100; width: 100%; height: 100%;"></canvas>');
            if (showConsole) console.log("canvas width='" + Math.round(cuttingFrameWidth) + "' - height='" + Math.round(cuttingFrameHeight) + "'");
            this.element.append(canvas);

            let canvasContextImageFrameCropped = $(canvas)[0].getContext('2d');
            let imageObj = new Image();
            imageObj.crossOrigin = "Anonymous";


            imageObj.onload = function () {

                let canvasTmp = $('<canvas width="' + Math.round(imageWidthParaCortar) + '" height="' + Math.round(imageHeightParaCortar) + '"></canvas>');
                let canvasImageOriginalGhost = $(canvasTmp)[0].getContext('2d');
                let tmpImage = $('<img src="" />');

                //canvasTmpContext.fillStyle = "rgba(255, 255, 255, 0)";
                //canvasTmpContext.clearRect(0,0,imageWidthParaCortar,imageHeightParaCortar);
                if (showConsole) console.log("canvasGhost width='" + imageWidthParaCortar + "' - height='" + imageHeightParaCortar + "'");
                canvasImageOriginalGhost.drawImage(imageObj, 0, 0, imageWidthParaCortar, imageHeightParaCortar);
                //this.element.append(canvasTmp);
                var tmpObj = new Image();
                tmpObj.crossOrigin = "Anonymous";
                tmpObj.onload = () => {

                    if (that.state.options.canvasImageOnly === true) {
                        if (showConsole) console.log("that.state.options.canvasImageOnly === true");
                        let _imageWidth = imageWidthParaCortar;
                        let _imageHeight = imageHeightParaCortar;
                        if (cuttingLeft < 0) {
                            _imageWidth += cuttingLeft;
                        } else if (cuttingLeft + imageWidthParaCortar > cuttingFrameWidth) {
                            _imageWidth = cuttingFrameWidth - cuttingLeft
                        }
                        if (cuttingTop < 0) {
                            _imageHeight += cuttingTop;
                        } else if (cuttingTop + imageHeightParaCortar > cuttingFrameHeight) {
                            _imageHeight = cuttingFrameHeight - cuttingTop
                        }

                        let canvasImageOnly = $('<canvas width="' + _imageWidth + '" height="' + _imageHeight + '"></canvas>');
                        let canvasImageOnlyContext = $(canvasImageOnly)[0].getContext('2d');

                        if (showConsole) console.log("canvasImageOnlyContext x='" + ((cuttingLeft < 0) ? cuttingLeft : 0) + "' - y='" + ((cuttingTop < 0) ? cuttingTop : 0) + "' drawImage='" + imageWidthParaCortar + "' - height='" + imageHeightParaCortar + "'");
                        canvasImageOnlyContext.drawImage(tmpObj, ((cuttingLeft < 0) ? cuttingLeft : 0), ((cuttingTop < 0) ? cuttingTop : 0), imageWidthParaCortar, imageHeightParaCortar);
                    }


                    if (imageWidthParaCortar < cuttingFrameWidth || imageHeightParaCortar < cuttingFrameHeight) {
                        //ctx.drawImage(image, dx, dy, dWidth, dHeight);
                        if (showConsole) console.log("true -> imageWidthParaCortar < cuttingFrameWidth || imageHeightParaCortar < cuttingFrameHeight");
                        if (showConsole) console.log("imageWidthParaCortar = '" + imageWidthParaCortar + "'");
                        if (showConsole) console.log("cuttingFrameWidth = '" + cuttingFrameWidth + "'");
                        if (showConsole) console.log("imageHeightParaCortar = '" + imageHeightParaCortar + "'");
                        if (showConsole) console.log("cuttingFrameHeight = '" + cuttingFrameHeight + "'");


                        if (showConsole) console.log("canvasContextImageFrameCropped x='" + cuttingLeft + "' - y='" + cuttingTop + "' width='" + imageWidthParaCortar + "' - height='" + imageHeightParaCortar + "'");
                        canvasContextImageFrameCropped.drawImage(tmpObj, cuttingLeft, cuttingTop, imageWidthParaCortar, imageHeightParaCortar);
                    } else {
                        //DOC: https://developer.mozilla.org/es/docs/Web/API/CanvasRenderingContext2D/drawImage
                        //ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);

                        if (showConsole) console.log("false -> imageWidthParaCortar < cuttingFrameWidth || imageHeightParaCortar < cuttingFrameHeight");
                        if (showConsole) console.log("imageWidthParaCortar = '" + imageWidthParaCortar + "'");
                        if (showConsole) console.log("cuttingFrameWidth = '" + cuttingFrameWidth + "'");
                        if (showConsole) console.log("imageHeightParaCortar = '" + imageHeightParaCortar + "'");
                        if (showConsole) console.log("cuttingFrameHeight = '" + cuttingFrameHeight + "'");


                        if (showConsole) console.log("canvasContextImageFrameCropped x='" + (cuttingLeft * -1) + "' - y='" + (cuttingTop * -1) + "' drawImage='" + cuttingFrameWidth + "' - height='" + cuttingFrameHeight + "'");
                        canvasContextImageFrameCropped.drawImage(tmpObj, cuttingLeft * -1, cuttingTop * -1, cuttingFrameWidth, cuttingFrameHeight, 0, 0, cuttingFrameWidth, cuttingFrameHeight);
                    }


                    let dataUrl = (that.state.options.canvasImageOnly === true) ? $(canvasImageOnly)[0].toDataURL(that.image.data('mime')) : $(canvas)[0].toDataURL(that.image.data('mime'));

                    if (that.state.options.save === false) {

                        that.element.find('.tools .saving').remove();
                        that.element.find('.tools').children().toggle();

                        if (that.state.options.onSave) that.state.options.onSave.call(that, $.extend(obj, that.state.options.data, {data: dataUrl}));
                        that.imageFinal();

                    } else if (that.state.options.ajax === true) {

                        that._ajax($.extend({dainformationDetailDescriptionLeft__withImageRatiota: dataUrl}, obj));

                    } else {

                        let json = JSON.stringify($.extend({data: dataUrl}, obj));
                        that.input.after($('<input type="text" name="' + that.input.attr('name') + '_values" class="final" />').val(json));

                        that.input.data('required', that.input.prop('required'));
                        that.input.prop('required', false);
                        that.input.wrap('<form>').parent('form').trigger('reset');
                        that.input.unwrap();

                        that.element.find('.tools .saving').remove();
                        that.element.find('.tools').children().toggle();

                        that.setState({
                            imageData: $.extend({data: dataUrl}, obj_save)
                        });

                        const imageObjSRC = that.image.attr('src');

                        if (that.state.options.saveOriginal === true) {
                            that.setState({
                                imageData: {
                                    ...that.state.imageData,
                                    ...obj
                                }
                            });
                        }

                        that.imageFinal();
                    }

                };
                tmpObj.src = $(canvasTmp)[0].toDataURL(that.image.data('mime'));


            };
            imageObj.src = this.image.attr('src');

            if (this.state.options.saveOriginal === true) {
                obj = $.extend({original: this.image.attr('src')}, obj);
            }

        } else {
            if (showConsole) console.log("this.state.options.canvas === false");

            that.setState({
                imageData: $.extend({
                    data: $(that.image).attr('src'),
                    saveOriginal: that.state.options.saveOriginal
                }, obj_save)
            });

            if (that.state.options.ajax === true) {

                that._ajax($.extend({
                    data: $(that.image).attr('src'),
                    saveOriginal: that.state.options.saveOriginal
                }, obj));

            } else {
                let finalImage = that.element.find('.cropWrapper').clone();
                $(finalImage).addClass('final').show().unbind().children().unbind();
                that.element.append($(finalImage));

                that.element.find('.tools .saving').remove();
                that.element.find('.tools').children().toggle();

                that.imageFinal();

                let json = JSON.stringify(obj);
                that.input.after($('<input type="text" name="' + that.input.attr('name') + '_values" class="final" />').val(json));
            }
        }
        // }
    }

    _ajax(obj) {
        if (showConsole) console.log("ImageDragAndDrop::_ajax()");
        var that = this;

        if (this.state.options.dimensionsonly === true) {
            delete obj.data;
        }

        $.ajax({
            type: 'POST',
            url: this.state.options.url,
            data: $.extend(obj, this.state.options.data),
            success: function (response) {

                if (response.status === "success") {
                    let file = response.url.split('?');
                    that.element.find('.tools .saving').remove();
                    that.element.find('.tools').children().toggle();
                    that.element.data('name', file[0]);
                    that.element.data('filename', response.filename);
                    if (that.state.options.canvas !== true) {
                        that.element.append($('<img src="' + file[0] + '" class="final" style="width: 100%" />'));
                    }

                    that.imageFinal();
                } else {
                    that.element.find('.tools .saving').remove();
                    that.element.find('.tools').children().toggle();
                    that.element.append($('<div class="alert alert-danger">' + response.error + '</div>').css({
                        bottom: '10px',
                        left: '10px',
                        right: '10px',
                        position: 'absolute',
                        zIndex: 99
                    }));
                    setTimeout(function () {
                        that.responseReset();
                    }, 2000);
                }
            },
            error: function (response, status) {
                that.element.find('.tools .saving').remove();
                that.element.find('.tools').children().toggle();
                that.element.append($('<div class="alert alert-danger"><strong>' + response.status + '</strong>' + response.statusText + '</div>').css({
                    bottom: '10px',
                    left: '10px',
                    right: '10px',
                    position: 'absolute',
                    zIndex: 99
                }));
                setTimeout(function () {
                    that.responseReset();
                }, 2000);
            }
        })
    }

    imageReset() {

        if (showConsole) console.log("ImageDragAndDrop::imageReset()");
        this.image.css({
            width: this.image.data('useWidth'),
            height: this.image.data('useHeight'),
            top: this.image.data('top'),
            left: this.image.data('left')
        });
        this._ghost();

        if (this.state.options.onAfterResetImage) this.state.options.onAfterResetImage.call(this, this);
    }

    imageFinal() {
        if (showConsole) console.log("ImageDragAndDrop::imageFinal()");
        //remove all children except final
        this.element.addClass('done');
        this.element.children().not('.final').hide();

        this.createToolsElements();

        this.props.imageChangeMethod(this.props.elementId, this.state.imageData);

        //custom function after process image;
        if (this.state.options.onAfterProcessImage) this.state.options.onAfterProcessImage.call(this, this);
    }

    createToolsElements() {
        if (showConsole) console.log("ImageDragAndDrop::createToolsElements()");
        var that = this;
        //create tools element
        let tools = $('<div class="tools final">');

        //edit option after crop
        if (this.state.options.buttonEdit !== false) {
            $(tools).append($(this.button.edit).click(() => {
                if (showConsole) console.log("boton edit pulsado ");
                that.element.addClass("dropzone-editing")
                that.element.children().show();
                that.element.find('.final').remove();
                that.input.data('valid', false);
                that.saveImageDataPreEdit()
            }));

        }

        //delete option after crop
        if (this.state.options.buttonDel !== false) {
            $(tools).append($(this.button.del).click((e) => {
                // if(showConsole) if (showConsole) console.log("boton delete pulsado");
                that.reset();
            }))
        }

        //append tools to element
        this.element.append(tools);
        this.element.unbind();

        //download
        if (this.state.options.download === true) {
            let download = $('<div class="download final"/>');
            $(download).append($(this.button.download).attr('download', $(this.image).attr('name')).click((e) => {
                $(that).attr('href', that.element.find('canvas.final')[0].toDataURL(this.image.data('mime')));
            }));
            this.element.append(download);
        }

        //set input to valid for form upload
        this.input.unbind().data('valid', true);
    }

    responseReset() {
        if (showConsole) console.log("ImageDragAndDrop::responseReset()");
        //remove responds from ajax event
        this.element.find('.alert').remove();
    }

    reset() {
        if (showConsole) console.log(this.props.elementId + " -> ImageDragAndDrop::reset()");
        this.element.find('.preview').remove();
        this.element.removeClass('loading done').children().show();//.not('input[type=file]').remove();
        this.input.wrap('<form>').parent('form').trigger('reset');
        this.input.unwrap();
        this.input.prop('required', this.input.data('required') || this.state.options.required || false).data('valid', false);
        this._bind();

        const that = this;

        if (this.state.options.removeurl !== null && !this.empty(this.element.data('name'))) {
            $.ajax({
                type: 'POST',
                url: that.state.options.removeurl,
                data: {image: this.element.data('name')},
                success: function (response) {
                    if (that.state.options.onAfterRemoveImage) this.state.options.onAfterRemoveImage.call(that, response, that);
                }
            })
        }
        this.element.data('name', null);

        if (this.imageGhost) {
            $(this.imageGhost).remove();
            this.imageGhost = null;
        }

        $(`#${this.props.elementId}.dropzone .tools`).remove();
        $(`#${this.props.elementId}.dropzone .cropWrapper`).remove();
        $('#' + this.props.elementId).find("canvas").remove();
        $(`#${this.props.elementId}.dropzone .final`).remove();

        this.setState({
            imageData: {}
        });

        this.props.imageChangeMethod(this.props.elementId, this.state.imageData);

        if (this.state.options.onAfterCancel) this.state.options.onAfterCancel.call(this);
    }

    saveImageDataPreEdit() {
        if (showConsole) console.log("ImageDragAndDrop::saveImageDataPreEdit()");
        const img = $('#' + this.props.elementId).find("img.main");
        this.state.imageDataCSSPreEdit = {
            width: img.css('width'),
            height: img.css('height'),
            top: img.css('top'),
            left: img.css('left'),
        }

        if (showConsole) console.log("this.state.imageDataCSSPreEdit = '" + JSON.stringify(this.state.imageDataCSSPreEdit) + "'");

    }

    onImageCancelEdit() {
        if (showConsole) console.log("ImageDragAndDrop::onImageCancelEdit()");
        let imgs = $('#' + this.props.elementId).find("img");

        const imagenDataCSSPreEdit = {
            width: this.state.imageDataCSSPreEdit.width,
            height: this.state.imageDataCSSPreEdit.height,
            top: this.state.imageDataCSSPreEdit.top,
            left: this.state.imageDataCSSPreEdit.left,
        }
        if (showConsole) console.log("imagenDataCSSPreEdit = '" + JSON.stringify(imagenDataCSSPreEdit) + "'");
        imgs.css(imagenDataCSSPreEdit);

        this.imageCrop(false, true);
    }

    resize() {
        if (showConsole) console.log("ImageDragAndDrop::resize()");
        if (this.state.options.resize !== true) return false;

        let oldWidth = this.element.outerWidth();

        //extraido de init()
        let width, height, imageWidth, imageHeight;

        this.state.options.width = imageWidth = this.element.outerWidth(true);
        this.state.options.height = imageHeight = this.element.outerHeight();

        width = this.state.options.width;
        height = this.state.options.height;

        let factor = oldWidth / width;

        height = width * 0.75;


        this.element.css({height: height, width: "100%"});

        if (width < 240) {
            if (!this.element.hasClass('smalltools smalltext')) {
                this.element.addClass('smalltools smalltext smalladded');
            }
        } else {
            if (this.element.hasClass('smalladded')) {
                this.element.removeClass('smalltools smalltext smalladded');
            }
        }

        if (!this.empty(this.image)) {

            this.image.css({
                left: this.image.css('left').replace(/[^-\d\.]/g, '') * factor + 'px',
                top: this.image.css('top').replace(/[^-\d\.]/g, '') * factor + 'px'
            })
            this.image.width(this.image.width() * factor);
            this.image.height(this.image.height() * factor);

            this._ghost();
        }
        return true;
    }

    reinit() {
        if (showConsole) console.log("ImageDragAndDrop::reinit()");
        this.resize();
        this._bind();

        return true;
    }

    modal() {
        if (showConsole) console.log("ImageDragAndDrop::modal()");
        this.element.attr('style', this.element.data('style'));
        this.element.attr('class', this.element.data('class'));

        this._init();

        return this;
    }

    _ghost() {
        if (showConsole) console.log("ImageDragAndDrop::_ghost()");
        //if set to true, mirror all drag events
        //function in one place, much needed

        if (this.state.options.ghost === true && !this.empty(this.imageGhost)) {

            //se tiene que coger los datos dinamicamente para poder hacer que ghost se desplace a la par que la imagen del frame
            const cssObj = {
                width: this.image.css('width'),
                height: this.image.css('height'),
                top: this.image.css('top'),
                left: this.image.css('left')
            }
            if (showConsole) console.log("imageGhost.css = '" + JSON.stringify(cssObj) + "'");
            $(this.imageGhost).css(cssObj)
        }
    }

    addEventListenerToTools() {
        if (showConsole) console.log("ImageDragAndDrop::addEventListenerToTools()");
        let tools = $('<div class="tools"></div>');
        var that = this;
        //zoomin button
        //if(showConsole) if (showConsole) console.log("Pulsado un boton de edicion");
        if (that.state.options.buttonZoomin !== false) {

            /*$(tools).append($(that.button.zoomin).on({
                'touchstart mousedown': function (e) {
                    // if(showConsole) if (showConsole) console.log("boton zoomin pulsado");

                    e.preventDefault();
                    e.cancelable = true;
                    that.interval = window.setInterval(function () {
                        that.imageZoom(2);
                    }, 10);
                },
                'touchend mouseup mouseleave': function (e) {
                    // if(showConsole) if (showConsole) console.log("boton zoomin despulsado");

                    e.preventDefault();
                    e.cancelable = true;
                    window.clearInterval(that.interval);
                    if (that.state.options.onAfterZoomImage) that.state.state.options.onAfterZoomImage.call(that, that);
                }
            }));*/
            let buttonZoomIn = $(that.button.zoomin);

            buttonZoomIn.on(
                'touchstart mousedown', function (e) {
                    // if(showConsole) if (showConsole) console.log("boton zoomin pulsado");

                    e.preventDefault();
                    e.cancelable = true;
                    that.interval = window.setInterval(function () {
                        that.imageZoom(2);
                    }, 10);
                }, /*{passive: false}*/
            );

            buttonZoomIn.on(
                'touchend mouseup mouseleave', function (e) {
                    // if(showConsole) if (showConsole) console.log("boton zoomin despulsado");

                    e.preventDefault();
                    e.cancelable = true;
                    window.clearInterval(that.interval);
                    if (that.state.options.onAfterZoomImage) that.state.state.options.onAfterZoomImage.call(that, that);
                }, /*{passive: false}*/
            );

            $(tools).append(buttonZoomIn);

        }

        //zoomreset button (set the image to the "original" size, same size as when selecting the image
        if (that.props.buttonZoomreset !== false) {
            /*$(tools).append($(that.button.zoomreset).on({
                'touchstart click': function (e) {
                    // if(showConsole) if (showConsole) console.log("boton zoomreset pulsado");

                    e.preventDefault();
                    e.cancelable = true;
                    that.imageReset();
                }
            }));*/
            $(tools).append($(that.button.zoomreset).on(
                'touchstart click', function (e) {
                    // if(showConsole) if (showConsole) console.log("boton zoomreset pulsado");

                    e.preventDefault();
                    e.cancelable = true;
                    that.imageReset();
                }, /*{passive: false}*/
            ));
        }

        //zoomout button
        if (that.props.buttonZoomout !== false) {
            $(tools).append($(that.button.zoomout).on({
                'touchstart mousedown': function (e) {
                    // if(showConsole) if (showConsole) console.log("boton zoomout pulsado");

                    e.preventDefault();
                    e.cancelable = true;
                    that.interval = window.setInterval(function () {
                        that.imageZoom(-2);
                    }, 10);
                },
                'touchend mouseup mouseleave': function (e) {
                    // if(showConsole) if (showConsole) console.log("boton zoomout despulsado");

                    e.preventDefault();
                    e.cancelable = true;
                    window.clearInterval(that.interval);
                    if (that.props.onAfterZoomImage) that.props.onAfterZoomImage.call(that, that);
                }
            }));
        }

        /*			if (that.props.buttonRotateccw != false) {
         $(tools).append($(that.button.rotateccw).on({
         'touchstart touchend click': function(e) {
         e.preventDefault();
                    e.cancelable=true;
         that.rotate(-90);
         }
         }));
         }
         if (that.props.buttonRotatecw != false) {
         $(tools).append($(that.button.rotatecw).on({
         'touchstart touchend click': function(e) {
         e.preventDefault();
                    e.cancelable=true;
         that.rotate(90);
         }
         }));
         }*/


        //cancel button (removes the image and resets it to the original init event
        if (that.props.buttonCancel !== false) {
            $(tools).append($(that.button.cancel).on({
                'touchstart touchend click': function (e) {
                    if (showConsole) console.log("boton cancel pulsado");

                    e.preventDefault();
                    e.cancelable = true;

                    if (Object.keys(that.state.imageData).length !== 0) {
                        that.onImageCancelEdit();
                    } else {
                        that.reset();
                    }
                }
            }));
        }
        //done button (crop the image!)
        var that = that;
        if (that.props.buttonDone !== false) {
            $(tools).append($(that.button.done).on({
                'touchstart click': function (e) {
                    // if(showConsole) if (showConsole) console.log("boton done pulsado");
                    e.preventDefault();
                    e.cancelable = true;
                    if (that.validarMargenesCorte()) {
                        that.element.removeClass('dropzone-editing')
                        // if(showConsole) if (showConsole) console.log("touch click -> ImageDragAndDrop::imageCrop(" + ")");
                        that.imageCrop(true)
                        //if(showConsole) if (showConsole) console.log("Done::touchstart click()");
                    }
                }
            }));
        }

        that.element.append($(tools));

    }

    _clearTimers() {
        if (showConsole) console.log("ImageDragAndDrop::_clearTimers()");
        //function to clear all timers, just to be sure!
        let interval_id = window.setInterval("", 9999);
        for (let i = 1; i < interval_id; i++)
            window.clearInterval(i);
    }

    _formValidation() {
        // if (showConsole) console.log("ImageDragAndDrop::_formValidation()");
        var that = this;
        this.element.closest('form').submit((e) => {

            //e.stopPropagation();
            $(that).find('input[type=file]').each((i, el) => {
                if ($(el).prop('required')) {
                    if ($(el).data('valid') !== true) {
                        e.preventDefault();
                        e.cancelable = true;
                        return false;
                    }
                }
            })
            return true;
        })
    }

    html5imageupload() {
        if (showConsole) console.log("ImageDragAndDrop::html5imageupload()");
        var that = this;
        if ($.data(that, "html5imageupload")) return;
        return $(that).each(() => {
            $.data(that, "html5imageupload", new $.html5imageupload(that.props.state.options, that));
        })
    }

    empty(mixed_var) {
        // if (showConsole) console.log("ImageDragAndDrop::empty()");
        let undef, key, i, len;
        let emptyValues = [undef, null, false, 0, '', '0'];

        for (i = 0, len = emptyValues.length; i < len; i++) {
            if (mixed_var === emptyValues[i]) {
                return true;
            }
        }

        if (typeof mixed_var === 'object') {
            for (key in mixed_var) {
                return false;
            }
            return true;
        }
        return false;
    }


    render() {
        // if (showConsole) console.log("ImageDragAndDrop::render()");
        let backgroundClass = "dropzone";
        if (Object.keys(this.state.imageData).length !== 0) {
            backgroundClass += " dropzoneActive";
        }
        return (
            <div
                className={backgroundClass}
                id={this.props.elementId}
                data-resize="true"
                data-ajax="false"
            >
                <input type="file" name="thumb"/>
            </div>
        );
    }

    componentDidMount() {
        if (showConsole) console.log("ImageDragAndDrop::componentDidMount()");
        this.element = $("#" + this.props.elementId);
        this.setState({
            options: $.extend(true, this.state.options, $(this.element).data())
        });
        this.input = $(this.element).find('input[type=file]');

        this.init();

        if (this.props.image !== undefined && Object.keys(this.props.image).length !== 0 && this.props.image.url !== undefined) {

            this.readImage(this.props.image.url, this.props.image.url, this.state.options.image, this.imageMimes["image" / this.props.image.url.split('.').pop()], false);
            // this.readImage(this.props.image.url, this.props.image.url, "nombre", this.imageMimes["image/png"], false);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (showConsole) console.log("ImageDragAndDrop::componentDidUpdate()");
        if (prevProps.image !== undefined && Object.keys(prevProps.image).length !== 0 && this.props.image === undefined) {
            this.reset();
        }
    }

    validarMargenesCorte() {
        if (showConsole) console.log("ImageDragAndDrop::validarMargenesCorte()");
        let factor = (this.state.options.width !== this.element.outerWidth()) ? this.state.options.width / this.element.outerWidth() : 1,
            cuttingFrameWidth, cuttingFrameHeight, cuttingTop, cuttingLeft, imageWidth, imageHeight;


        cuttingFrameWidth = this.state.options.width;
        cuttingFrameHeight = cuttingFrameWidth * 0.75;
        cuttingTop = parseInt(Math.round(parseInt(this.image.css('top')) * factor));
        cuttingLeft = parseInt(Math.round(parseInt(this.image.css('left')) * factor));
        imageWidth = parseInt(Math.round(this.image.width() * factor));
        imageHeight = parseInt(Math.round(this.image.height() * factor));


        let arrayError = [];
        if (cuttingLeft > 0) {
            arrayError.push('izquierdo');
        }

        if ((cuttingTop < 0 && (imageHeight - Math.abs(cuttingTop)) < cuttingFrameHeight) ||
            (cuttingTop > 0 && (imageHeight + Math.abs(cuttingTop)) < cuttingFrameHeight)) {
            arrayError.push('inferior');
        }


        if ((cuttingLeft < 0 && (imageWidth - Math.abs(cuttingLeft)) < cuttingFrameWidth) ||
            (cuttingLeft > 0 && (imageWidth + Math.abs(cuttingLeft)) < cuttingFrameWidth)) {
            arrayError.push('derecho');
        }

        if (cuttingTop > 0) {
            arrayError.push('superior');
        }


        if (arrayError.length > 0) {
            this.element.addClass("dropzone-error");
            this.element.removeClass("dropzone-success");

            Alert.warning('Imagen mal ajustada al margen: ' + arrayError.join(', ').replace(/,(?!.*,)/gmi, ' y'), {
                position: 'top-right',
                effect: 'slide',
                timeout: 3000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true
                }
            });
            return false;
        } else {
            this.element.addClass("dropzone-success");
            this.element.removeClass("dropzone-error");
            return true;

        }

    }
}


export default ImageDragAndDrop
